import axios from 'axios'
import {React , useEffect } from 'react'
import Chip from '@material-ui/core/Chip';
const Genres = ({type,selectedGenres,setSelectedGenres,genres,setGenres,setPage}) => {

  const handleAdd = (genre)=>{
    setSelectedGenres([...selectedGenres,genre]);
    // eslint-disable-next-line
    setGenres(genres.filter((g)=>g.id !== genre.id));
    // eslint-disable-next-line
    setPage(1);
    // eslint-disable-next-line
  }
  const handleRemove = (genre)=>{
    setSelectedGenres(selectedGenres.filter((g)=>g.id !== genre.id));
    // eslint-disable-next-line
    setGenres([...genres,genre]);
    // eslint-disable-next-line
    setPage(1);
    // eslint-disable-next-line
  }

  const fetchgenre = async ()=>{
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/genre/${type}/list?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`
    )
    setGenres(data.genres);
    // eslint-disable-next-line
  }
  useEffect(() => {
   fetchgenre()
   // eslint-disable-next-line
   return ()=>{
     setGenres({});// unmounting
     // eslint-disable-next-line
   }
   // eslint-disable-next-line
  }, [])
  // eslint-disable-next-line

  return (
    <>
      <div style={{ padding: "6px 0" }}>
      {selectedGenres.map((genre) => (
        <Chip
          style={{ margin: 2 }}
          label={genre.name}
          key={genre.id}
          color="primary"
          clickable
          size="small"
          onDelete={() => handleRemove(genre)}
        />
      ))}
      {genres.map((genre) => (
        <Chip
          style={{ margin: 2 }}
          label={genre.name}
          key={genre.id}
          color="secondary"
          clickable
          size="small"
          onClick={() => handleAdd(genre)}
        />
      ))}
    </div>
    </>
  )
}

export default Genres
